import { useState, useCallback } from "react";
import { toast } from "sonner";
import { fetchFastApi } from "../api/fastapi";

export function useUpdateAttributeTestResult() {
  const [updating, setUpdating] = useState(false);

  const updateResult = useCallback(
    async (
      resultId: string,
      payload: Record<string, string | number | object | boolean | null>,
    ): Promise<boolean> => {
      setUpdating(true);
      try {
        await fetchFastApi({
          path: `/matching/attribute-test-results/${resultId}`,
          method: "PATCH",
          body: payload,
          // An `error_message` envelope is a rejected update; without this it
          // resolves and would be reported (and cached) as a success.
          throwOnErrorEnvelope: true,
        });

        toast.success("Updated successfully");
        return true;
      } catch (error) {
        console.error("Error updating attribute test result:", error);
        toast.error("Failed to update");
        return false;
      } finally {
        setUpdating(false);
      }
    },
    [],
  );

  return {
    updating,
    updateResult,
  };
}
